import { array, string, object } from 'yup'

import mixpanelTrack from 'lib/mixpanel-track'

const validateEmails = (arrayOfUserData, emailToCheck, arrayOfInputEmails) => {
  const userEmails = arrayOfUserData.map((userData) =>
    userData.email.toLowerCase()
  )
  const filteredEmails = arrayOfInputEmails.filter((email) => {
    // filter out the userEmails to prevent them from inviting themselves
    if (userEmails.includes(email.toLowerCase())) {
      return false
    }
    // check if any users are trying to invite the creator, works only with main email of creator for now
    if (email.toLowerCase() === emailToCheck.toLowerCase()) {
      return false
    }
    return true
  })
  return filteredEmails
}

export const submit = (
  mutate,
  elementId,
  currentUserData,
  creatorEmail,
  slug
) => {
  return ({ emails }, { resetForm, setSubmitting }) => {
    const filteredEmails = validateEmails(currentUserData, creatorEmail, emails)
    mutate({ variables: { elementId, emails: filteredEmails } }).then(() => {
      mixpanelTrack('Invito Inviato', {
        id: slug,
      })

      setSubmitting(false)
      resetForm()
    })
  }
}

export const validationSchema = object().shape({
  emails: array().of(string().email()).min(1).required(),
})
